import { CourseRegistry } from '../../types';
import { regexCourse } from './regexCourse';
import { dspyCourse } from './dspyCourse';
import { llmFoundationsCourse } from './llmFoundationsCourse';

export const courseRegistry: CourseRegistry = {
  'regex-learning': regexCourse,
  'dspy-mastery': dspyCourse,
  'llm-foundations': llmFoundationsCourse,
};
